/*============================================================================
  Global - header
==============================================================================*/
var header = {
  init: function () {
    //remove duplicate header on update
    // if ($('.mobile-header').length > 1) {
    //   var nav_menu = $("#nav").data("mmenu");
    //   nav_menu.close();
    //   $('.mobile-header:last, #nav:last').remove();
    // }
    if ($('.header').length > 1) {
      $('.header.mm-slideout').remove();
    }

    //Promo banner
    if ($('.promo_banner').length) {
      fetch('https://ipapi.co/json/?key=UkCB6gTudfTr6N21cJyhEzHkYrYiBybM4yortn7qSKAv6kG8b6')
        .then(function (response) {
          response.json().then(jsonData => {
            window.localizationCountry = jsonData.country;
            if (jsonData.country != undefined) {
              if (jsonData.country === 'CA') {
                $('.promo_banner p').html($('.promo_banner').data('text-ca') + ' Canada!');
              } else if (jsonData.country === 'US') {
                $('.promo_banner p').html($('.promo_banner').data('text-usa') + ' USA!');
              } else {
                $('.promo_banner p').html($('.promo_banner').data('text-world') + ' ' + jsonData.country_name);
              }
            } else {
              $('.promo_banner p').text('🚀 Fast shipping');
            }
            $('.promo_banner p, .promo_banner a').fadeTo(200, 1);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if ($('.mobile-header:hidden') && $('.default-header').hasClass('behind-menu--true')) {
      $('.default-header').parent('.header-section').addClass('header--content-behind');
    }

    if ($('.default-header').hasClass('mm-fixed-top')) {
      $(window).scroll(function () {
        var promoBannerHeight = $('.header .promo_banner').height() + 15;
        if ($(document).scrollTop() > promoBannerHeight) {
          $('.header.default-header').addClass('header--hide-promo');
        } else {
          $('.header.default-header').removeClass('header--hide-promo');
        }
      })
    }

    $('#cart').mmenu({
      navbar: {
        add: false
      },
      offCanvas: { position: 'right', wrapPageIfNeeded: false },
      "extensions": [
        `theme-${window.themeSettings.mobileMenuColor}`
      ]
    });

    $('.icon-cart, .icon-menu').on("click", function (e) {
      $('#search').hide();
    });

    $(".icon-search").on('click', function (e) { $(this).parent('form').submit(); });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 768) {
      $(document).on('click', '.menu li.sub-menu > a', function (e) {
        e.preventDefault();
        return false;
      });
    }

    $('body').on('mouseover', '.sub-menu .dropdown-link', function () {
      if (window.outerWidth > 767) {
        const menuHolder = $(this).closest('.js-menu-holder');
        const button = menuHolder.find('.toggle-button.sub-menu-opener');
        if (button.length) {
          button.attr('aria-expanded', 'true');
        }
      }
    });
    $('body').on('mouseout', '.sub-menu .dropdown-link', function () {
      if (window.outerWidth > 767) {
        const menuHolder = $(this).closest('.js-menu-holder');
        // Only update if menu is not explicitly opened
        if (!menuHolder.hasClass('open')) {
          const button = menuHolder.find('.toggle-button.sub-menu-opener');
          if (button.length) {
            button.attr('aria-expanded', 'false');
          }
        }
      }
    });
    banner.init();

    $('#cart').each(function () {
      $(this)[0].setAttribute('action', '/checkout');
    });
  },
  unload: function ($target) {
    $('a[href^="#"]').off('click');
  }
}

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function () {
    var flg = 0;
    var $faqHeading = $('.faqAccordion > .dt > button');
    $('.faqAccordion > dd').attr('aria-hidden', true);
    $faqHeading.attr('aria-expanded', false);
    $faqHeading.on('click activate', function () {
      if (flg) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded', state);
      $(this).parent().next().slideToggle(100, function () {
        flg = 0;
      });
      $(this).parent().next().attr('aria-hidden', !state);
      return false;
    });
    $faqHeading.on('keydown', function (event) {
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger('activate');
      }
    });
  }
}

/*============================================================================
  All pages - banners
==============================================================================*/

var banner = {
  init: function () {

    if ($(window).width() >= 768) {

      if ($('[data-secondary-logo]').length) {
        $('.header .logo').addClass('secondary-logo--true');
        var totalHeaderHeight = $('.header').outerHeight();
      } else {
        $('.header .logo').addClass('secondary-logo--false');
        var totalHeaderHeight = $('.header').outerHeight();
      }
    }

    // Add space for header so banner images display directly below
    if ($('.behind-menu--false').length && $('.banner-section.wide_display--true').length) {
      $('.shadow-header').css('height', totalHeaderHeight);
    }

    //Pages without banner images display the default header style
    if ($('.banner-section.wide_display--true').length == 0 && $('.draggable-banner--true').length == 0) {
      $('.header').addClass('header_bar');
    }

    //Page.details and index templates - possible for wide-display banner to be top section
    if ($('.behind-menu--false').length && $('.draggable-banner--true').children().first().find('.wide_display--true').length) {
      $('.shadow-header').css('height', totalHeaderHeight);
      if ($(window).width() < 768) {
        $('.draggable-banner--true').children().first().addClass('main_content_area');
      }
    } else if ($('.draggable-banner--true').children().first().find('.wide_display--true').length == 0) {
      $('.draggable-banner--true').children().first().addClass('main_content_area');
      $('.draggable-banner--true').parents('body').find('.header').addClass('header_bar');
      if ($(window).width() < 768) {
        $('.draggable-banner--true').parents('body').find('.header').addClass('header_bar');
      }
    }

  },
  unload: function ($target) {
    if ($('.banner-section.wide_display--true').length == 0 && $('.draggable-banner--true').length == 0) {
      $('.header').removeClass('header_bar');
    }

    $('.banner-section').attr('style', '');
    $('.shadow-header').attr('style', '');
    $('.draggable-banner--true').children().removeClass('main_content_area');
  }
}

/*============================================================================
  Home page - slideshow
==============================================================================*/

var slideshow = {
  init: function () {
    $('.homepage_slider').each(function (index, value) {
      var homepageSlider = $(this);
      var slideshowAnimation = homepageSlider.data('slideshow-animation');
      var slideshowSpeed = homepageSlider.data('slideshow-speed');
      // homepageSlider.flexslider({
      //   touch: true,
      //   controlNav: true,
      //   animation: slideshowAnimation,
      //   slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
      //   fadeFirstSlide: false
      // });

      // if($('.slides li', homepageSlider).length == 1) {
      //   $('.flex-direction-nav', homepageSlider).hide();
      // };

    });

  },
  unload: function ($target) {
    var slider = $target.find('.homepage_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function () {
  return !!document.createElement('video').canPlayType;
}

var homepageVideo = {
  unload: function ($target) {
    $target.find('[data-play-video]').off('click');
  },
  getVideoDetails: function (settings) {
    var videoDetails = {
      id: settings.header.attr('data-video-src'),
      aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
      provider: settings.header.attr('data-provider'),
      videoMP4: settings.header.attr('data-video-mp4'),
      videoOGV: settings.header.attr('data-video-ogv')
    }
    return videoDetails;
  },
  createFrame: function (settings, videoDetails) {

    if (videoDetails.provider === 'youtube') {
      if (settings.autoloop) {
        var autoloop = '1&iv_load_policy=3&playlist=' + videoDetails.id;
      } else {
        var autoloop = 0;
      }

      var html = '<iframe src="//www.youtube.com/embed/' + videoDetails.id + '?&autoplay=1&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if (videoDetails.provider === 'vimeo') {
      if (settings.autoloop) {
        var autoloop = 1;
      } else {
        var autoloop = 0;
      }
      var html = '<iframe src="//player.vimeo.com/video/' + videoDetails.id + '?loop=' + autoloop + '&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if (videoDetails.provider === 'html5') {
      if (settings.autoloop) {
        var autoloop = 'loop="loop"';
      }

      var html = '<video autoplay="true" ' + autoloop + ' id="video"><source src="' + videoDetails.videoMP4 + '" type="video/mp4"><source src="' + videoDetails.videoOGV + '" type="video/ogg" ></video>';
    }
    else if (videoDetails.provider === 'empty') {
      if (settings.autoloop) {
        var autoloop = '1&iv_load_policy=3&playlist=' + '_9VUPq3SxOc';
      } else {
        var autoloop = 0;
      }

      var html = '<iframe src="//www.youtube.com/embed/' + '_9VUPq3SxOc' + '?&autoplay=1&loop=' + autoloop + '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    return html;
  },
  appendFrame: function (settings, videoDetails) {
    var addVideo = function () {
      //only add video if there are no videos already in the section
      if (settings.container.find('.mediaWrapper').length < 1 && settings.container.find('#video').length < 1) {
        settings.container.find('.js-append-video').append(homepageVideo.createFrame(settings, videoDetails));
      }

      if (videoDetails.provider != 'html5') {
        settings.container.find('iframe').mediaWrapper({
          intrinsic: false,
          baseWidth: videoDetails.aspectRatio[0],
          baseHeight: videoDetails.aspectRatio[1]
        });
      }
    }

    if (!homepageVideo.isMobile()) {
      addVideo();
      var mediaWrapper = settings.container.find('.mediaWrapper');
      settings.container.height(mediaWrapper.outerHeight());
      settings.posterImage.addClass('fadeOut animated');

      if (settings.bannerVideoText) {
        settings.videoText.addClass('text-on-video');
      } else {
        settings.videoText.hide();
      }

      settings.header.next().fadeIn('slow');
      if (videoDetails.provider != 'html5') {
        mediaWrapper.find('iframe').show();
      } else {
        settings.header.next().show();
        settings.container.find('.homepage-video__placeholder').hide();
        settings.container.find('.homepage-video__image').hide();
      }

      settings.videoTrigger.removeAttr('data-play-video');

    }
  },
  isMobile: function () {
    return false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) return true;
  }
}

var video = {
  init: function () {

    //Check for videos that are set to autoplay
    $('.homepage-video').each(function (index, value) {
      if ($('.homepage-video').length && supports_video()) {

        var $videoElement = $(this);
        var settings = {
          container: $videoElement,
          header: $videoElement.find('.homepage-video--media'),
          posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
          videoText: $videoElement.find('.homepage-video--media .caption'),
          videoTrigger: $videoElement.find("[data-play-video]"),
          autoPlayVideo: $videoElement.data('autoplay'),
          bannerVideoText: $videoElement.data('video-text'),
          autoloop: $videoElement.data('autoloop')
        }
        var videoDetails = homepageVideo.getVideoDetails(settings);

        if (settings.autoPlayVideo && !homepageVideo.isMobile()) {
          homepageVideo.appendFrame(settings, videoDetails);
        }

      }
    });

    //Attach event listener for videos
    $(document).on('click', '[data-play-video]', function (e) {
      var $videoElement = $(this).parents('.homepage-video');
      var settings = {
        container: $videoElement,
        header: $videoElement.find('.homepage-video--media'),
        posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
        videoText: $videoElement.find('.homepage-video--media .caption'),
        videoTrigger: $videoElement.find("[data-play-video]"),
        autoPlayVideo: $videoElement.data('autoplay'),
        bannerVideoText: $videoElement.data('video-text'),
        autoloop: $videoElement.data('autoloop')
      }
      var videoDetails = homepageVideo.getVideoDetails(settings);

      homepageVideo.appendFrame(settings, videoDetails);
    });
  }
}

/*============================================================================
  Home page - testimonials
==============================================================================*/

var testimonials = {
  init: function () {
    $('.testimonial_slider').each(function (index, value) {
      var testimonialSlider = $(this);

      testimonialSlider.flexslider({
        touch: true,
        animation: 'slide',
        slideshowSpeed: 10 * 1000,
        fadeFirstSlide: false
      });
    });

  },
  unload: function ($target) {
    var slider = $target.find('.testimonial_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
  twitter: function () {
    if (window.twttr) {
      window.twttr.ready(function (twttr) {
        twttr.widgets.load();
      });
    }
  },
  unload: function () {

  }
}

/*============================================================================
  Product
==============================================================================*/

var product = {
  init: function () {
    var $productSection = $('.product_slider').parents('.product_section');
    var thumbnailPosition = $productSection.data('thumbnail');
    var slideshowAnimation = $productSection.data('slideshow-animation');
    var slideshowSpeed = $productSection.data('slideshow-speed');
    // var $notify_form = $('.notify_form .contact-form');

    if ($productSection.parents("#quickshop__btn-look").length == 0 &&
      slideshowAnimation == 'zoom' && $(window).width() >= 768) {
      $('.image__container img', $productSection)
        .wrap('<div></div>')
        .parent()
        .zoom({
          magnify: 1
        });
      $('.image__container .zoomImg', $productSection).attr({
        'alt': '',
        'aria-hidden': 'true'
      });
    }

    var slider = $('.product_slider').flexslider({
      startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
      touch: true,
      pauseOnHover: true,
      controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
      directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
      animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
      slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
      slideshowSpeed: slideshowSpeed ? slideshowSpeed * 1000 : 10 * 1000,
      start: function (slider) {
        slider.resize();

        var $currentSlider = $(slider);

        // Keep the raw product slides hidden until FlexSlider has finished
        // sizing them, then cross-fade from the CLS placeholder to the gallery.
        window.requestAnimationFrame(function () {
          $currentSlider.addClass('gallery-ready');
          $currentSlider.find('.product-images-gallery-cls-overlay').addClass('gallery-ready');
        });

 
        // Accessibility for thumbnails
        document.querySelectorAll('.flex-control-nav.flex-control-thumbs li img').forEach(function (el, index) {
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');

          // Set aria-current on active thumbnail
          if (index === 0) {
            el.setAttribute('aria-current', 'true');
          }

          // Set aria-label
          let totalSlides = document.querySelectorAll('.flex-control-nav.flex-control-thumbs li img').length;
          let currentIndex = index + 1; 

          el.setAttribute('aria-label', 'image ' + currentIndex + ' of ' + totalSlides);
          
          el.addEventListener('keydown', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
              e.preventDefault();
              el.click();
              el.setAttribute('aria-current', 'true');
            }
          });

          // Click event
          el.addEventListener('click', function (e) {
            // Remove aria-current from all thumbnails
            document.querySelectorAll('.flex-control-nav.flex-control-thumbs li img').forEach(function (el) {
              el.removeAttribute('aria-current');
            });
            el.setAttribute('aria-current', 'true');
          })
        });
      }
    });

    if ($('.slides li:not(.clone)', $productSection).length == 1) {
      $('.flex-direction-nav', slider).hide();
    }

    $('.product_form.product_form_options.init').each(function () {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    $('#product-form select[name="id"]').change(function () {
      var optionTitle = $('option:selected', this).attr('data-title');

      if ($('input[value="' + optionTitle + '"]').length) {
        $('input[value="' + optionTitle + '"]').click();
      }
      $('#product-form select[name="idSticky"] option[data-title="' + optionTitle + '"]').attr("selected", "selected");
    });

    $('#product-form select[name="idSticky"]').change(function () {
      var optionTitle = $('option:selected', this).attr('data-title');

      if ($('input[value="' + optionTitle + '"]').length) {
        $('input[value="' + optionTitle + '"]').click();
      }
    });


    // $notify_form.each(function() {
    //   var $nf = $(this);
    //   $nf.on("submit", function (e) {
    //     if($('input[name="challenge"]', $nf).val() !== "true") {
    //       $.ajax({
    //         type: $nf.attr('method'),
    //         url: $nf.attr('action'),
    //         data: $nf.serialize(),
    //         success: function (data) {
    //           $nf.fadeOut("slow", function(){
    //             $nf.prev('.message').html({{ 'products.notify_form.post_success' | t | json }});
    //           });
    //         },
    //         error: function(data) {
    //           $('input[name="challenge"]', $nf).val('true');
    //           $nf.submit();
    //         }
    //       });
    //       e.preventDefault();
    //     }
    //   });
    // });

    if (window.themeSettings?.productFormStyle === 'swatches') {
      $('.product_form').addClass('is-visible');
      function reduceByPercentage(price) {
        var discountPercentage = 5 / 100;
        return (price - (price * discountPercentage)).toFixed(2)
      }
      $('.swatch :radio').change(function () {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        // If master option changes
        if ($(this).attr('name') == 'option-0') {
          //create Options Array based on Selection
          var allValues = $(this).closest('.swatch').attr('data-options-values').split('|');
          var optionsData = {};
          $.each(allValues, function (index, value) {
            var arrData = value.split(',');
            var price = parseFloat(arrData.pop());
            var title = arrData[0];
            var master_option = arrData[1];
            if (master_option == optionValue) {

              var optionElem = $('.swatch-element[data-value="' + arrData[2] + '"] .swatch-price-per-unit p');

              //Format Replace data
              var content_units_parts = title.split(' ');

              var amount = Math.abs(parseFloat(content_units_parts[content_units_parts.length - 2]));
              var unit = content_units_parts[content_units_parts.length - 1];
              var price_per_unit;
              if (amount != 0) {
                price_per_unit = price / amount;
                if (unit.indexOf('lb') >= 0) {
                  price_per_unit = price_per_unit / 16;
                  unit = 'oz.';
                }
                if (unit.indexOf('gallon') >= 0) {
                  price_per_unit = price_per_unit / 128;
                  unit = 'oz.';
                }
              } else {
                price_per_unit = price;
              }

              // Replace data
              console.log(price);
              // optionElem.find('.price').html(Shopify.formatMoney(price,$('body').data('money-format')));

              if ($('input[data-radio-subsave]:checked').length > 0) {
                var showPrice = reduceByPercentage(
                  ((price / 100).toFixed(2))
                );
                $('.current_price').css('visibility', 'hidden');
                setTimeout(function () {
                  $('.current_price .money').text(Shopify.formatMoney(showPrice, $('body').data('money-format')))
                  $('.current_price').css('visibility', 'visible');
                })
              }
              if (amount == 1) return;
              // Format price per unit
              var price_per_unit_formatted;
              if (unit == 'ea.') {
                price_per_unit_formatted = '(' + Shopify.formatMoney(price_per_unit, $('body').data('money-format')) + ' ' + unit + ')';
              } else {

                if (unit == 'beans') {
                  unit = 'bean';
                }
                price_per_unit_formatted = '(' + Shopify.formatMoney(price_per_unit, $('body').data('money-format')) + '/' + unit + ')';
              }
              optionElem.find('.price-per-unit').html(price_per_unit_formatted);
            }
          });

        }

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    }

  },
  unload: function ($target) {
    var slider = $target.find('.product_slider');
    destroySlider(slider);
  }
}


/*============================================================================
  Collection
==============================================================================*/

var collection = {
  init: function () {

    if (window.themeSettings?.collectionSwatches) {
      if ($(window).width() >= 768) {
        $('.thumbnail').hover(function () {
          $('.swatch span', $(this)).each(function () {
            if ($(this).data("image").indexOf("no-image") == -1) {
              $('<img/>')[0].src = $(this).data("image");
            }
          });
        })
        $('.swatch span').hover(function () {
          if ($(this).data("image").indexOf("no-image") == -1) {
            $(this).parents('.thumbnail').find('img').attr('src', $(this).data("image"));
            $(this).parents('.thumbnail').find('img').attr('srcset', $(this).data("image"));
          }
        });
      }
    }


    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
      .on('change', '#tag_filter, #sort-by', function () {
        var sortValue = $('#sort-by').val();
        var filterValue = $('#tag_filter').val();

        Shopify.queryParams.sort_by = sortValue;
        sortUrl = $.param(Shopify.queryParams);

        if (sortValue && filterValue) {
          window.location = filterValue + '?sort_by=' + sortValue;
        } else if (sortValue && !filterValue) {
          window.location = '?' + sortUrl;
        } else if (!sortValue && filterValue) {
          window.location = filterValue;
        }
      });
  },
  unload: function ($target) {
    $target.find('.thumbnail').off('mouseenter mouseleave');
    $('body').off('change', '#tag_filter, #sort-by');
  }
}

/*============================================================================
  Page Banner Template
==============================================================================*/

var pageBanner = {
  init: function () {
    $('.banner-flexslider').flexslider({
      touch: false,
      controlNav: false,
      directionNav: false,
      animation: "fade"
    });
  },
  unload: function ($target) {
    var slider = $target.find('.banner-flexslider');
    destroySlider(slider);
  }
}

/*============================================================================
  Map
==============================================================================*/

var map = {
  init: function () {
    if ($(".map-section .map, .contact-template-section .map, .page-details-section .map, .product-details-section .map").hasClass('js-api-map')) {
      var mapsToLoad = [];

      //Create map settings array
      $('.map').each(function (i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });

      $.each(mapsToLoad, function (i, instance) {

        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });

        //Load maps script and find location coordinates
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey).then(function () {
          map.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },

  findLocation: function (mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();

    //Find and set coordinates
    geocoder.geocode({ 'address': mapArray.address }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {

        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();

        //Create map
        map.initMap(geoLat, geoLng, mapArray);

      }
    });
  },

  initMap: function (lat, lng, mapArray) {

    var location = { lat: lat, lng: lng };
    var styleJson = [];

    //Set style JSON
    if (mapArray.mapstyle == 'aubergine') {
      styleJson = [{ "elementType": "geometry", "stylers": [{ "color": "#1d2c4d" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#8ec3b9" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#1a3646" }] }, { "featureType": "administrative.country", "elementType": "geometry.stroke", "stylers": [{ "color": "#4b6878" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#64779e" }] }, { "featureType": "administrative.province", "elementType": "geometry.stroke", "stylers": [{ "color": "#4b6878" }] }, { "featureType": "landscape.man_made", "elementType": "geometry.stroke", "stylers": [{ "color": "#334e87" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#023e58" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#283d6a" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#6f9ba5" }] }, { "featureType": "poi", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#023e58" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#3C7680" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#304a7d" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#98a5be" }] }, { "featureType": "road", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#2c6675" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#255763" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#b0d5ce" }] }, { "featureType": "road.highway", "elementType": "labels.text.stroke", "stylers": [{ "color": "#023e58" }] }, { "featureType": "transit", "elementType": "labels.text.fill", "stylers": [{ "color": "#98a5be" }] }, { "featureType": "transit", "elementType": "labels.text.stroke", "stylers": [{ "color": "#1d2c4d" }] }, { "featureType": "transit.line", "elementType": "geometry.fill", "stylers": [{ "color": "#283d6a" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#3a4762" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#0e1626" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#4e6d70" }] }];
    } else if (mapArray.mapstyle == 'retro') {
      styleJson = [{ "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] }, { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] }, { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#a5b076" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] }, { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] }, { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }];
    } else if (mapArray.mapstyle == 'silver') {
      styleJson = [{ "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f5f5" }] }, { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#bdbdbd" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "color": "#757575" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#dadada" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#616161" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }, { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#e5e5e5" }] }, { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#eeeeee" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#c9c9c9" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#9e9e9e" }] }];
    } else if (mapArray.mapstyle == 'night') {
      styleJson = [{ "elementType": "geometry", "stylers": [{ "color": "#242f3e" }] }, { "elementType": "labels.text.fill", "stylers": [{ "color": "#746855" }] }, { "elementType": "labels.text.stroke", "stylers": [{ "color": "#242f3e" }] }, { "featureType": "administrative.locality", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#263c3f" }] }, { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#6b9a76" }] }, { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#38414e" }] }, { "featureType": "road", "elementType": "geometry.stroke", "stylers": [{ "color": "#212a37" }] }, { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#9ca5b3" }] }, { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#746855" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#1f2835" }] }, { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "color": "#f3d19c" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#2f3948" }] }, { "featureType": "transit.station", "elementType": "labels.text.fill", "stylers": [{ "color": "#d59563" }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#17263c" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#515c6d" }] }, { "featureType": "water", "elementType": "labels.text.stroke", "stylers": [{ "color": "#17263c" }] }];
    } else {
      styleJson = [];
    }

    //Create google maps link
    $('.js-map-link').attr('href', 'https://www.google.com/maps/place/' + mapArray.directions + '/@' + lat + ',' + lng);

    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };

    //Create map
    var map = new google.maps.Map(document.getElementById(mapArray.sectionid), mapOptions);

    //Show pin
    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
}

/*============================================================================
  Product form
==============================================================================*/

var productFormListeners = {
  init: function () {
    $(document).on("click", ".minus", function (e) {
      var quantity = parseInt($(this).next("input").val());
      quantity -= 1;
      $(this).next("input").val(quantity);
      if (quantity == 0) {
        $(this).closest('li.cart_item').slideUp(100);
        var itemToRemove = $(this).next().data('id');
        $('.item--' + itemToRemove).remove();
        setTimeout(ajaxSubmitCart, 500);
      } else {
        $(this).next("input").trigger('change');
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", ".plus", function (e) {
      var quantity = parseInt($(this).prev("input").val());
      quantity += 1;
      $(this).prev("input").val(quantity).trigger('change');

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("change", ".quantity_dropdown select", function (e) {

      var quantity = $(this).val();
      if (quantity !== '-') {
        $(this).closest('.cart_item').find('input').val(quantity).trigger('change');
      }

      e.stopPropagation();
      e.preventDefault();

      setTimeout(() => {
        //Refocus back to quantity element after change event
        //The quantity element is actually destroyed and rebuilt, so we need to querySelector again to get it
        const quantityElement = document.querySelector(`#${this.id}`);
              quantityElement.focus();
      }, 1000);

      return false;
    });

    $(document).on("change", "#cart_form input[type='number']", function () {
      var $cartForm = $(this).closest("#cart_form");

      // Cart drawer quantities are updated asynchronously by CartDrawer.
      // Submitting its form here redirects the customer to the cart page.
      if ($cartForm.hasClass("cart-drawer__form")) return;

      $cartForm.submit();
    }).delay(200);

    if ($('.tos_agree').length) {
      $('body').on('click', 'input[type="submit"]', function () {
        if ($(this).parents('form').find('.tos_agree').length) {
          if ($(this).parents('form').find('.tos_agree').is(':checked')) {
            $(this).submit();
          } else {
            alert(window.themeTranslations.agreeToTermsWarning);
            return false;
          }
        } else {
          $(this).submit();
        }
      });
    }
  },
  unload: function () {

  }
}

/*============================================================================
  Cart
==============================================================================*/

if ($('[data-close-toast]').length) {
  $('[data-close-toast]').on('click', function () {
    $('[data-cart-toast]').removeClass('is-visible').css('top', '-99%');
  });

  $('[data-toast-view-cart]').on('click', function (e) {
    e.preventDefault();
    $('[data-cart-toast]').removeClass('is-visible').css('top', '-99%');
    window.setTimeout(function () {
      $.fancybox.close();
      var drawerTrigger = document.querySelector('[data-cart-drawer-open]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = $(e.currentTarget).attr('href') || window.routes.cart_url;
      }
    }, 500);
  });
}


var ajaxCart = {
  init: function () {
    $('body').on('submit', '.product_form form', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartInfo = $(this).parent('.product_form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      $('[data-cart-toast]').removeClass('is-visible').css('top', '-99%');
      window.lastFocusedElement = document.activeElement;
      $.ajax({
        url: window.routes.cart_add_url + '.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
        },
        success: function (itemData) {
          $addToCartBtn.find('span').text(window.variantStrings.productAdded).removeClass('zoomOut').addClass('fadeIn');

          window.setTimeout(function () {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
          }, 1000);

          $.ajax({
            url: window.routes.cart_url + '.js',
            dataType: "json",
            cache: false,
            success: function (cart) {
              refreshCart(cart);
              $('[data-cart-toast]').removeClass('is-visible').css('top', '-99%');

              // The 2026 cart experience replaces the legacy success toast with
              // a freshly-rendered drawer so the newly-added item is visible
              // immediately without a hard reload.
              if (window.PXUTheme && window.PXUTheme.cartDrawer && typeof window.PXUTheme.cartDrawer.loadDrawer === 'function') {
                window.PXUTheme.cartDrawer.loadDrawer(true);
              }
              // Trigger custom event
              document.documentElement.dispatchEvent(new CustomEvent('cart:added', {
                bubbles: true
              }));
            }
          });
          $(".quickshop__modal-close").click();
        },
        error: function (XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.variantStrings.addToCart).removeClass('zoomOut').addClass('zoomIn');
          $(".quickshop__modal-close").click();
        }
      });

      return false;
    });
  },
  unload: function () {

  }
}

/*============================================================================
  Utils
==============================================================================*/
var utils = {
  initializeTabs: function () {
    var tabs = $('ul.tabs');
    tabs.each(function (i) {
      var tab = $(this).find('> li > a');
      tab.on('click', function (e) {
        var contentLocation = $(this).attr('href');
        if (contentLocation.charAt(0) == "#") {
          e.preventDefault();
          tab.removeClass('active');
          $(this).addClass('active');
          $(this).parents('ul.tabs').next().find(contentLocation).show().css({ 'display': 'block' }).addClass('active').siblings().hide().removeClass('active');
        }
      });
    });
  },
  initializeAccordions: function () {
    var allPanels = $('.accordion > dd').hide();
    $('.accordion > dt > a').on('click', function () {
      if (!$(this).parent().next().is(":visible")) {
        allPanels.slideUp(100);
        $('.accordion small.right').html('&#9668;');
        $(this).find('small.right').html('&#9660;');
        $(this).parent().next().slideDown(100);
      }
      return false;
    });
    $($('.accordion dd')[0]).show();
  },
  unload: function ($target) {
    $('ul.tabs > li > a').off('click');
    $('.accordion > dt > a').off('click');
  }
}

var toggleSidebarBlocks = function ($toggle) {
  if ($toggle.next('ul').is(':visible')) {
    $toggle.next('ul').slideUp(100);
    //$toggle.children('span').html('<i class="fa fa-angle-down"></i>');
    $toggle.attr('aria-expanded', false);
  } else {
    $toggle.next('ul').slideDown(100);
    //$toggle.children('span').html('<i class="fa fa-angle-up"></i>');
    $toggle.attr('aria-expanded', true);
  }
}

var toggleSidebarMenus = function ($toggle) {
  var $menu = $toggle.parent('li');

  var $toggleIcon = $menu.children('.menu-toggle');

  $menu.toggleClass('submenu--active');

  //var iconType = $menu.hasClass('submenu--active') ? '<i class="fa fa-angle-up arrow_Up"></i>' : '<i class="fa fa-angle-down arrow_Down"></i>';
  //$toggleIcon.html(iconType);

  $menu.children('ul').slideToggle(100);
  $toggleIcon.attr('aria-expanded', $toggleIcon.attr('aria-expanded') == 'true' ? 'false' : 'true');

}

var sliderBlock = {
  select: function (blockId, $parentSection) {
    var $blocks = $parentSection.find('li[data-block-id]:not(".clone")');
    var blockIdsArray = $blocks.map(function () {
      return String($(this).data('block-id'));
    });

    var slider = $parentSection.find('.flexslider').data('flexslider');

    slider.pause();

    for (var i = 0; i < blockIdsArray.length; i++) {
      if (blockIdsArray[i] === blockId) {
        var currentSlide = i;
        if (currentSlide !== slider.currentSlide) {
          slider.flexAnimate(parseInt(currentSlide));
        }
      }
    }
  },
  deselect: function ($parentSection) {
    var slider = $parentSection.find('.flexslider').data('flexslider');
    if (slider) {
      slider.play();
    }
  }
}

//Document ready
$(function () {

  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = 1500;
  window.lazySizesConfig.loadMode = 1;

  //Load sections
  slideshow.init();
  header.init();
  map.init();
  testimonials.init();
  product.init();
  faqAccordion.init();
  collection.init();
  productFormListeners.init();
  video.init();
  banner.init();

  //Sidebar toggle
  $(document).on('click', '.menu-toggle, .parent-link--false', function (e) {
    toggleSidebarMenus($(this));
  });

  var sidebarTouched = false;
  $(document).on('touchstart', '.toggle', function (e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      toggleSidebarBlocks($toggle);
      sidebarTouched = true;
      e.preventDefault();
      return false;
    }
  });
  $(document).on('click', '.toggle', function (e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      if (!sidebarTouched) {
        toggleSidebarBlocks($toggle);
        e.preventDefault();
        return false;
      }
    }
  });

  if ($('.header-section .logo-below').length > 0) {
    $('#content .index-sections').removeClass('adjust-header');
  } else {
    $('#content .index-sections').addClass('adjust-header');
  }

  // Load Accordions
  utils.initializeAccordions();

  // Load Tabs
  utils.initializeTabs();

  $('.slider').flexslider({
    touch: false,
    directionNav: false,
    controlNav: false,
    animation: "fade",
    fadeFirstSlide: false
  });

  $('.slider-no-nav').flexslider({
    touch: false,
    controlNav: false,
    directionNav: false,
    animation: "fade",
    fadeFirstSlide: false
  });

  $('.slider-no-nav-quick').flexslider({
    touch: false,
    controlNav: false,
    directionNav: false,
    animation: "fade",
    slideshowSpeed: 4000,
    fadeFirstSlide: false
  });

  $("body").on("click", '.continue', function () {
    var cart = $("#cart").data("mmenu");
    if (cart != null) {
      cart.close();
    }

    var nav = $("#nav").data("mmenu");
    if (nav != null) {
      nav.close();
    }
    setTimeout(function () {
      var modal = $('#quickshop__btn-look');
      modal.fadeOut();
    }, 250);
  });

  $("body").on("click", '#search-toggle-desktop, #search-toggle-mobile, .search-close', function (e) {
    if (window.autocompleteInstance.autocomplete.getVal() != '' && e.currentTarget.id != 'search-toggle') {
      window.autocompleteInstance.autocomplete.setVal('');
    }
    else {
      const headerHeight = $('.header').height();
      const adjustedHeaderHeight = headerHeight > 100 ? headerHeight - 54 : headerHeight;
      $('.search-close').css('padding-top', adjustedHeaderHeight + 100 + 'px')
      if ($('#search').is(":visible") && $(window).scrollTop() == 0) {
        $(".index .header").removeClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
      } else {
        $(".index .header").addClass('header_bar');
        $('.index .header .logo img').attr('src', $('.logo img').data('src'));
      }
      $('#search').fadeToggle('fast').find('input').focus();
    }
    e.stopPropagation();
    e.preventDefault();
  });
  $("body").on("focusout", '#search', function (e) {
    if (window.autocompleteInstance.autocomplete.getVal() != '') {
      setTimeout(() => {
        window.autocompleteInstance.autocomplete.open();
      }, 1);
    }
    e.preventDefault();
  });

  if ($('.flexslider img').length == 1) { $('.flexslider .flex-direction-nav').hide() }
  $(".search-submit").on('click', function (e) { $(this).parent('form').submit(); });
  $('.lightbox').fancybox();

  if ($(window).width() >= 959) {

    var modal_width = '860px';

    if ($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1100px'
    }
  }

$(".fancybox").fancybox({
  padding: 0,
  wrapCSS: 'gallery',
  afterShow: function (instance, current) {
    setTimeout(function () {     
      let closeBtn = document.querySelector('.fancybox-close');
      // Focus the close button
      closeBtn.focus();
      
      // Trap focus within the modal
      document.querySelectorAll('[role="dialog"]').forEach(trapFocus);

      // Close button should close on Enter key
      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          $.fancybox.close();
        }
      });
      console.log(closeBtn);
    }, 100 );
  },
  afterClose: function (instance, current) {
    // Restore focus to the trigger element
    this.element.focus();
  }
});


  if (window.themeSettings?.collectionSwatches) {
    if ($(window).width() >= 768) {
      $('.thumbnail').hover(function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data("image").indexOf("no-image") == -1) {
            $('<img/>')[0].src = $(this).data("image");
          }
        });
      })
      $('.swatch span').hover(function () {
        if ($(this).data("image").indexOf("no-image") == -1) {
          $(this).parents('.thumbnail').find('img').attr('src', $(this).data("image"));
        }
      });
    }
  }

  $('#tag_filter').change(function () { window.location = $('#tag_filter option:selected').val(); });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }


  if ($('.shopify-section.page-details-section, .product_gallery').length) {
    // Don't apply mediaWrapper
  } else if ($('body').hasClass('index')) {
    $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  } else {
    $('iframe[src*=youtube], iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  }

  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);

  if (params.has('customer_posted') && params.get('customer_posted') === 'true' || params.has('contact[tags]')) {
    $('html, body').animate({
      scrollTop: $('#shopify-section-footer').offset().top
    }, 1000);
  }

  if (window.themeSettings?.productFormStyle === 'swatches') {
    $('.swatch :radio').change(function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  }

  $('.maps').on('click', function () {
    $('.maps iframe').css("pointer-events", "auto");
  });



  /*============================================================================
    Home page - social media
  ==============================================================================*/

  //Initialize twitter feed
  if ($('.twitter-feed-wrap').length) {
    window.twttr = (function (d, s, id) {
      var t, js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return; js = d.createElement(s); js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);
      return window.twttr || (t = { _e: [], ready: function (f) { t._e.push(f) } });
    }(document, "script", "twitter-wjs"));

    $('.twitter-feed-wrap').each(function (index, value) {
      social.twitter();
    });
  }

  $('body').on("change", "#cart input.quantity", function () {
    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart'));
  });

  $('body').on("change", "#cart #cart-note", function () {
    ajaxSubmitCart();
  });

  $(document).on("click", ".mm-subtitle .cart-note-show", function (e) {
    e.preventDefault();
    $(e.target).hide();
    $(".mm-fullsubopen").css("display", "block !important");
    $("#cart-note").removeClass("hide");
    $("#cart-note").focus();
  });

  $(document).on("keypress", ".mm-subtitle .cart-note-show", function (e) {
    if (e.which === 13) {
      e.preventDefault();
      $(e.target).hide();
      $(".mm-fullsubopen").css("display", "block !important");
      $("#cart-note").removeClass("hide");
      $("#cart-note").focus();
    }
  });

  $('.quantity__button').click(function () {
    var type = $(this).attr('name');
    var $quantityField = $(this).parents('.quantity__controls').find('[name="quantity"]');
    //var previousValue = $quantityField.val();

    if (type === 'minus') {
      $quantityField.val((i, v) => Math.max(1, +v + 1 * -1));
    } else {
      $quantityField.val((i, v) => Math.max(1, +v + 1));
    }

    return false;
  });

  if (window.themeSettings?.cartAction === 'ajax') {
    ajaxCart.init();
    
    // Fetch and refresh cart on load to ensure sidecart is fully populated
    $.ajax({
      url: (window.routes ? window.routes.cart_url : '/cart') + '.js',
      dataType: 'json',
      cache: false,
      success: function (cart) {
        if (typeof refreshCart2 === 'function') {
          refreshCart2(cart);
        }
      }
    });
  }

});

/*============================================================================
  Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() {
  $cart = $("#cart");
  $.ajax({
    url: window.routes.cart_update_url + '.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
      refreshCart(data);
    }
  });
}

function ajaxUpdateCart(lineID, quantity, parent) {

  $.ajax({
    url: window.routes.cart_change_url + '.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: { quantity: quantity, line: lineID },
    success: function (data) {
      refreshCart(data);
      refreshIndicator(data);
      var lineIDIndex = lineID - 1;
      var $input = parent.find("input[data-line-id='" + lineID + "']");

      //check to see if there are correct amount of products in array
      if (typeof data.items[lineIDIndex] === "undefined") {
        var updated_quantity = 0;
      } else {
        var updated_quantity = data.items[lineIDIndex].quantity;
      }

      if (quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          items_left_text = window.themeTranslations.itemsLeftCountOne;
        } else {
          items_left_text = window.themeTranslations.itemsLeftCountOther;
        }

        $('.warning--quantity').remove();

        var warning = '<div class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</div>';

        $input.parent().next().find(".item_info").append(warning);
        $input.val(updated_quantity);
      }
    }
  });
}

function refreshCart(cart) {
  var $addToCartBtn = $('.product_form form .add_to_cart');

  $('#cart').each(function () {
    $(this)[0].setAttribute('action', '/checkout');
  });

  if ($addToCartBtn.hasClass('no-cart-drawer')) window.location.href = '/cart';
  else refreshCart2(cart);
}

function refreshIndicator(cart) {
  refreshCartButtonCounts(cart);
}

function cartVisualText(count) {
  return count + ' ' + (count === 1 ? 'item in cart' : 'items in cart');
}

function refreshCartButtonCounts(cart) {
  var count = Number(cart?.item_count ?? cart) || 0;
  var accessibleText = cartVisualText(count);

  // The current header uses its own count element instead of the legacy
  // `.cart-button` markup handled below. Keep it in sync after AJAX cart
  // additions and quantity changes as well.
  $('[data-header-cart-count]')
    .text(count)
    .toggleClass('header-controls__cart-count--empty', count === 0);

  $('.sfg-cart-item-count').text(`${count} ${count === 1 ? 'Item' : 'Items'}`);

  $('.cart-button').each(function () {
    var $button = $(this);
    var $a11yCount = $button.find('[data-cart-count-a11y]').first();
    var $visibleCount = $button.find('[data-cart-count-visible]').not('.visually-hidden').first();
    var $badge = $button.find('.cart_count').first();

    if (!$a11yCount.length) {
      $a11yCount = $button.find('.visually-hidden').first();

      if (!$a11yCount.length) {
        $a11yCount = $('<span class="visually-hidden" data-cart-count-a11y></span>');
        $button.append($a11yCount);
      } else {
        $a11yCount.attr('data-cart-count-a11y', '');
      }
    }

    $a11yCount.text(accessibleText);

    if ($visibleCount.length) {
      $visibleCount.attr('aria-hidden', 'true').text(count);
    }

    if (count > 0) {
      if (!$badge.length && !$visibleCount.length) {
        $badge = $('<div class="cart_count" aria-hidden="true" data-cart-count-visible></div>');
        $button.prepend($badge);
      }

      $badge.attr('aria-hidden', 'true').attr('data-cart-count-visible', '').text(count);
    } else {
      $badge.remove();
    }
  });
}

function refreshCart2(cart) {

  $cartBtn = $(".icon-cart");
  if ($cartBtn) {
    var cart_items_html = "";
    var $cart = $("#cart ul");

    refreshCartButtonCounts(cart);

    $cart.find('li:not(:first)').remove();
    let selected_product_id = '';

    if (cart.item_count == 0) {
      $cart.append(`<li class="mm-label empty_cart"><a id="to-cart-a" tabindex="0" href="/cart">${window.themeTranslations?.emptyCart}</a></li>`);
    } else {
      $.each(cart.items, function (index, item) {
        var line_id = index + 1;
        selected_product_id = item.product_id;
        cart_items_html += '<li class="cart_item"><div class="item-group" role="group" aria-label="Cart item">';

        cart_items_html += '<a id="to-product-pdp" tabindex="0" href="' + item.url + '">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
            '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="" />' +
            '</div>';
        }

        cart_items_html += '<div class="item_info"><h3>' + item.title + '</h3>';

        if (item.selling_plan_allocation?.selling_plan?.name) {
          cart_items_html += '<div class="line-item">' + item.selling_plan_allocation.selling_plan.name + '</div>';
        }

        cart_items_html += '<div class="price"><span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></div></div></a>';

        cart_items_html += '<p class="mm-counter quantity_selector quantity_dropdown" id="quantity_dropdown--' + index + '">' +
          '<select tabindex="0">' +
          '<option tabindex="0" value="0">Remove</option>';
        for (var i = 1; i <= item.quantity; i++) {
          if (i == item.quantity) {
            cart_items_html += '<option tabindex="0" value="' + i + '" selected>' + i + '</option>';
          } else {
            cart_items_html += '<option tabindex="0" value="' + i + '">' + i + '</option>';
          }
        }
        cart_items_html += '</select>' +
          '</p>' +
          '<p class="mm-counter quantity_selector quantity_input">' +
          '<span tabindex="0" class="minus">-</span>' +
          '<input tabindex="0" type="number" min="0" class="updates quantity" name="updates[]" id="updates_' + item.id + '" data-id="' + item.id + '" value="' + item.quantity + '"  data-line-id="' + line_id + '" readonly />' +
          '<span tabindex="0" class="plus">+</span>' +
          '</p>';
        
        cart_items_html += '</div></li>';
      });

      if (window.localizationCountry != "US") {
        cart_items_html += '<li class="mm-label free-shipping-text" style="display: flex;"><p>' + window.variantStrings.shipping + '</p><p>' + window.variantStrings.free + '</p></li>';
      }
      cart_items_html += '<li class="mm-label">' +
        '<a id="to-cart-a" tabindex="0" href="/cart">' +
        '<strong>' + window.variantStrings.subtotal + '</strong>' +
        '</a>' +
        '<p class="mm-counter"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></p>' +
        '</li>' +
        '<li class="mm-subtitle clearfix">';

      $('#cart_form .subtotal_amount .money').empty().append(Shopify.formatMoney(cart.total_price, $cart.data('money-format')));

      if (window.themeSettings?.displaySpecialInstructions) {
        var cart_note = cart.note ? cart.note : '';
        cart_items_html += '<button type="button" tabindex="0" class="cart-note-show span shameless">+ ' + window.variantStrings.addCartNote + '</button><textarea tabindex="0" id="cart-note" name="note" rows="2" placeholder="' + window.variantStrings.cartNote + '" class="clearfix hide">' + cart_note + '</textarea>';
      }

      if (window.themeSettings?.displayTosCheckbox) {
        cart_items_html += `<aside class="tos tos_checkbox"><input tabindex="0" type="checkbox" class="tos_agree" id="sliding_agree" required /><label class="tos_label" for="sliding_agree">${window.themeSettings?.tosRichtext}</label></aside>`;
      }

      cart_items_html += '<div class="checkout-buttons-holder">' +
        '<a tabindex="0" id="edit-cart-a" href="' + window.routes.cart_url + '" class="action_button edit_cart">' + window.variantStrings.editCart + 
        '</a>' +
        '<input id="checkout-button" tabindex="0" type="submit" class="action_button" value="' + window.variantStrings.checkout + '" />' +
        '</div>';

      const bgColor = window.themeSettings?.cartBannerColor;
      const textColor = window.themeSettings?.textColor;

      if (window.themeSettings?.bannerMessage && window.themeSettings?.bannerMessage != '') {
        cart_items_html += '<div class="cart-banner-message" style="background-color: #' + bgColor + '; color: #' + textColor + ';">' +
          window.themeSettings?.bannerIcon ?? '<input type="hidden">' +
          '<span>' + window.themeSettings?.bannerMessage ?? '' + '</span>' +
          '</li></div>';
      }



      cart_items_html += '<li class="mm-subtitle clearfix text-center prod-recom-title" data-page="product" style="clear: both; display: none;"><h3 class="span">' + window.variantStrings.recommendedForYou + '</h3></li>';

      if (selected_product_id != null) {
        let lang_prefix = window.Shopify.routes.root;
        $.ajax({
          type: "GET",
          url: window.location.origin + lang_prefix + "recommendations/products.json?product_id=" + selected_product_id + "&limit=2",
          success: function (products) {
            let items = [];
            $.each(products['products'], function (indx, product) {
              items.push('<li class="mm-subtitle clearfix text-center cart_item " style="clear: both;"><div class="prod-box" role="group" aria-label="product"><div class="mm-selected"><div class="cart_image"><img src="' + product.featured_image + '" alt=""></div><div class="item_info"><a class="recommended-product-title" href="' + lang_prefix + '/products/' + product.handle + '"><h3>' + product.title + '</h3></a><div class="price" data-wg-notranslate="manual"><span data-wg-notranslate="manual">' + Shopify.formatMoney((parseInt(product.price) / 100.0).toFixed(2), $("body").data("money-format")) + '</span></div><span class="stamped-product-reviews-badge stamped-main-badge" data-id="' + product.id + '" style="display: block;"></span></div></div><p class="mm-counter"><a tabindex="0" id="add-to-cart-button" class="text animated zoomIn btn-add-cart" data-vid="' + product.variants[0].id + '">' + window.variantStrings.addToCart + '</a></p></div></li>');
            });

            $(items.join("")).insertAfter(".prod-recom-title");
            $(".prod-recom-title").show();

            bindProductAddToCart();


            if (window && window.StampedFn) {
              window.StampedFn.reloadUGC();
            }
          }
        });

        function bindProductAddToCart() {
          $(".prod-box .btn-add-cart").click(function () {
            $.ajax({
              type: 'POST',
              url: window.routes.cart_add_url + ".js",
              dataType: 'json',
              data: {
                quantity: 1,
                id: $(this).data("vid")
              },
              success: function (data) {
                $.ajax({
                  url: window.routes.cart_url + ".js",
                  dataType: "json",
                  cache: false,
                  success: function (cart) {
                    refreshCart(cart);
                    window.setTimeout(function () { $.fancybox.close(); $('.cart-button').click(); }, 500);
                  }
                });
              }
            });
          });
        }

      }

      if (window.localizationCountry == "US") {
        cart_items_html += '<li class="mm-subtitle clearfix text-center" style="clear: both; border-top: 1px solid #dedede; border-bottom: 1px solid #dedede; margin-top: 15px;">' +
          '<p class="cart-notes">' +
          `<img src="${window.themeSettings?.freeShippingSvg}"" alt="">${window.variantStrings.freeShippingOrders}</p></li>`;
      }

      cart_items_html += '<li class="mm-subtitle ajx-reviews clearfix text-center" style="clear: both;text-align: center;">' +
        `<img src="${window.themeSettings?.bbbBanner}" alt="Better Business Bureau A+ Rating – Accredited Business" style="height: 48px; margin: 14px 0px 14px;"></li>`;

      $cart.append(cart_items_html);

      setTimeout(function () {
        var badgeContainer = document.querySelector(".mm-subtitle.ajx-reviews");
        var ratingBadgeContainer = document.createElement("div");
        badgeContainer?.appendChild(ratingBadgeContainer);
        window.gapi.load('ratingbadge', function () {
          window.gapi.ratingbadge.render(
            ratingBadgeContainer, {
            "merchant_id": 111112397,
            "position": "INLINE",
            "lang": 'en_US'
          });
        });
      }, 5000);

      if (cart.item_count > 0) {
        $.each(cart.items, function (index, item) {
          $.ajax({
            type: 'GET',
            url: `/products/${item.handle}?view=inventory-quantity`,
            success: function (response) {
              // inventory not tracked
              if (item.quantity) {
                var response = item.quantity + 100;
              } else if (Number(response) < 1) {
                var response = 100;
              }
              $(`#quantity_dropdown--${index}`).html(response);
              var select_html = `
              <label for="cart-quantity-select-${index}" class="visually-hidden">Quantity</label>
              <select class="cart-quantity-select-c" tabindex="0" id="cart-quantity-select-${index}">
                <option class="cart-quantity-option" value="-">Quantity</option>
                <option class="cart-quantity-option" value="0">Remove</option>`;
              for (var i = 1; i < response; i++) {
                if (i == item.quantity) {
                  select_html += `<option value="${i}" selected>${i}</option>`;
                } else {
                  select_html += `<option value="${i}">${i}</option>`;
                }
              }
              select_html += `</select>`;
              $(`#quantity_dropdown--${index}`).html(select_html);
            },
            error: function (status) {
              console.warn('ERROR', status);
            }
          })
        });
      }

      if (false && window.themeSettings?.showMultipleCurrencies) {
        convertCurrencies();
      }

      // update on cart page
      $("#cart_form .quantity").each(function (index) {
        var thisLineID = index + 1;
        var lineToMatch = $('#cart .cart_item .quantity[data-line-id="' + thisLineID + '"]').val();
        if (lineToMatch !== undefined) {
          $(this).val(lineToMatch);
        }
      });


      $('#cart').each(function () {
        $(this)[0].setAttribute('action', '/checkout');
      });

    }
  }
}

selectCallback = function (variant, selector) {

  var $product = $('.product-' + selector.product.id);
  // var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.product_gallery', $product);
    $sliders.each(function () {
      var $slider = $(this);
      if ($slider.is(":visible")) {
        $slider.flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index'));
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function (v) {
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);
    // $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

    if (window.themeSettings?.productFormStyle === 'swatches') {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g, '\\"') + '"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    }
  }



  if (variant && variant.available == true) {

    if (variant.price < variant.compare_at_price) {
      $('.was_price', $product).html('<span class="money"><span class="sr-only">Original price: </span>' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.current_price', $product).parent().addClass('sale');

      var savings = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
      var savings_text = window.themeTranslations.savings;
      $('.price_wrapper .savings', $product).html(
        savings_text.replace('savings', Math.floor(savings)).replace(/{/g, '').replace(/}/g, '')
      ).show();

      var off = variant.compare_at_price - variant.price;
      $('.price_wrapper .off', $product).html('(-' + Shopify.formatMoney(off, $('body').data('money-format')) + ')').show();
    } else {
      $('.was_price', $product).html('')
      $('.current_price', $product).parent().removeClass('sale');
      $('.price_wrapper .savings', $product).html('').hide();
      $('.price_wrapper .off', $product).html('').hide();
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      if (window.themeSettings?.displayInventoryLeft) {
        if (variant.inventory_quantity == 1) {
          var items_left_text = window.themeTranslations.itemsLeftCountOne;
        } else {
          var items_left_text = window.themeTranslations.itemsLeftCountOther;
        }

        var inventoryThreshold = window.themeSettings?.inventoryThreshold;
        if (variant.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(variant.inventory_quantity + " " + items_left_text);
        } else {
          $('.items_left', $product).html("");
        }
      }
      if (window.themeSettings?.limitQuantity) {
        if (variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      }
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money" data-swatch-price="' + variant.price + '"><span class="sr-only">Current price: </span>' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    } else {
      $('.current_price', $product).html(window.themeSettings?.freePriceText);
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    // $notify_form.hide();
  } else {
    var message = variant ? window.variantStrings.soldOut : window.variantStrings.unavailable;
    $('.was_price', $product).html('');
    $('.current_price', $product).html('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    if ($('.add_to_cart', $product).hasClass('presale')) {
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text("Reserve Presale");
    }
    $('.price_wrapper .savings', $product).html('').hide();
    $('.price_wrapper .off', $product).html('').hide();

    $('.shopify-payment-button', $product).hide();
    // $notify_form.hide();
    // if (variant && !variant.available) {
    //     $notify_form.fadeIn();
    // }
  }

  if (false && window.themeSettings?.showMultipleCurrencies) {
    convertCurrencies();
  }

  $productForm.removeClass("init");
};

function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}

// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com

!function (t) { t.fn.mediaWrapper = function (i) { var e = t.extend({ intrinsic: !0, baseWidth: 16, baseHeight: 9 }, i); return this.each(function () { var i = ""; i = 1 == e.intrinsic && "" !== t(this).attr("width") && "" !== t(this).attr("height") ? t(this).attr("height") / t(this).attr("width") * 100 : e.baseHeight / e.baseWidth * 100, t(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' + i + '% 0 0 0; " />').css({ position: "absolute", width: "100%", height: "100%", top: "0", left: "0" }) }) } }(jQuery);

/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

function PointerEventsPolyfill(t) { if (this.options = { selector: "*", mouseEvents: ["click", "dblclick", "mousedown", "mouseup"], usePolyfillIf: function () { if ("Microsoft Internet Explorer" == navigator.appName) { var t = navigator.userAgent; if (null != t.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)) { var e = parseFloat(RegExp.$1); if (11 > e) return !0 } } return !1 } }, t) { var e = this; $.each(t, function (t, n) { e.options[t] = n }) } this.options.usePolyfillIf() && this.register_mouse_events() } PointerEventsPolyfill.initialize = function (t) { return null == PointerEventsPolyfill.singleton && (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(t)), PointerEventsPolyfill.singleton }, PointerEventsPolyfill.prototype.register_mouse_events = function () { $(document).on(this.options.mouseEvents.join(" "), this.options.selector, function (t) { if ("none" == $(this).css("pointer-events")) { var e = $(this).css("display"); $(this).css("display", "none"); var n = document.elementFromPoint(t.clientX, t.clientY); return e ? $(this).css("display", e) : $(this).css("display", ""), t.target = n, $(n).trigger(t), !1 } return !0 }) };

/* option_selection.js */
function floatToString(t, e) { var o = t.toFixed(e).toString(); return o.match(/^\.\d+/) ? "0" + o : o } if ("undefined" == typeof Shopify) var Shopify = {}; Shopify.each = function (t, e) { for (var o = 0; o < t.length; o++)e(t[o], o) }, Shopify.map = function (t, e) { for (var o = [], i = 0; i < t.length; i++)o.push(e(t[i], i)); return o }, Shopify.arrayIncludes = function (t, e) { for (var o = 0; o < t.length; o++)if (t[o] == e) return !0; return !1 }, Shopify.uniq = function (t) { for (var e = [], o = 0; o < t.length; o++)Shopify.arrayIncludes(e, t[o]) || e.push(t[o]); return e }, Shopify.isDefined = function (t) { return "undefined" == typeof t ? !1 : !0 }, Shopify.getClass = function (t) { return Object.prototype.toString.call(t).slice(8, -1) }, Shopify.extend = function (t, e) { function o() { } o.prototype = e.prototype, t.prototype = new o, t.prototype.constructor = t, t.baseConstructor = e, t.superClass = e.prototype }, Shopify.locationSearch = function () { return window.location.search }, Shopify.locationHash = function () { return window.location.hash }, Shopify.replaceState = function (t) { window.history.replaceState({}, document.title, t) }, Shopify.urlParam = function (t) { var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch()); return e && decodeURIComponent(e[1].replace(/\+/g, " ")) }, Shopify.newState = function (t, e) { var o; return o = Shopify.urlParam(t) ? Shopify.locationSearch().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + e) : "" === Shopify.locationSearch() ? "?" + t + "=" + e : Shopify.locationSearch() + "&" + t + "=" + e, o + Shopify.locationHash() }, Shopify.setParam = function (t, e) { Shopify.replaceState(Shopify.newState(t, e)) }, Shopify.Product = function (t) { Shopify.isDefined(t) && this.update(t) }, Shopify.Product.prototype.update = function (t) { for (property in t) this[property] = t[property] }, Shopify.Product.prototype.optionNames = function () { return "Array" == Shopify.getClass(this.options) ? this.options : [] }, Shopify.Product.prototype.optionValues = function (t) { if (!Shopify.isDefined(this.variants)) return null; var e = Shopify.map(this.variants, function (e) { var o = "option" + (t + 1); return void 0 == e[o] ? null : e[o] }); return null == e[0] ? null : Shopify.uniq(e) }, Shopify.Product.prototype.getVariant = function (t) { var e = null; return t.length != this.options.length ? e : (Shopify.each(this.variants, function (o) { for (var i = !0, r = 0; r < t.length; r++) { var n = "option" + (r + 1); o[n] != t[r] && (i = !1) } return 1 == i ? void (e = o) : void 0 }), e) }, Shopify.Product.prototype.getVariantById = function (t) { for (var e = 0; e < this.variants.length; e++) { var o = this.variants[e]; if (t == o.id) return o } return null }, Shopify.money_format = "${{amount}}", Shopify.formatMoney = function (t, e) { function o(t, e) { return "undefined" == typeof t ? e : t } function i(t, e, i, r) { if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0; t = (t / 100).toFixed(e); var n = t.split("."), a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i), s = n[1] ? r + n[1] : ""; return a + s } "string" == typeof t && (t = t.replace(".", "")); var r = "", n = /\{\{\s*(\w+)\s*\}\}/, a = e || this.money_format; switch (a.match(n)[1]) { case "amount": r = i(t, 2); break; case "amount_no_decimals": r = i(t, 0); break; case "amount_with_comma_separator": r = i(t, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": r = i(t, 0, ".", ",") }return a.replace(n, r) }, Shopify.OptionSelectors = function (t, e) { return this.selectorDivClass = "selector-wrapper", this.selectorClass = "single-option-selector", this.variantIdFieldIdSuffix = "-variant-id", this.variantIdField = null, this.historyState = null, this.selectors = [], this.domIdPrefix = t, this.product = new Shopify.Product(e.product), this.onVariantSelected = Shopify.isDefined(e.onVariantSelected) ? e.onVariantSelected : function () { }, this.replaceSelector(t), this.initDropdown(), e.enableHistoryState && (this.historyState = new Shopify.OptionSelectors.HistoryState(this)), !0 }, Shopify.OptionSelectors.prototype.initDropdown = function () { var t = { initialLoad: !0 }, e = this.selectVariantFromDropdown(t); if (!e) { var o = this; setTimeout(function () { o.selectVariantFromParams(t) || o.fireOnChangeForFirstDropdown.call(o, t) }) } }, Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (t) { this.selectors[0].element.onchange(t) }, Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (t) { var e = this.selectVariantFromParams(t); e || this.selectVariantFromDropdown(t) }, Shopify.OptionSelectors.prototype.replaceSelector = function (t) { var e = document.getElementById(t), o = e.parentNode; Shopify.each(this.buildSelectors(), function (t) { o.insertBefore(t, e) }), e.style.display = "none", this.variantIdField = e }, Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) { var e = document.getElementById(this.domIdPrefix).querySelector("[selected]"); if (e || (e = document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')), !e) return !1; var o = e.value; return this.selectVariant(o, t) }, Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) { var e = Shopify.urlParam("variant"); return this.selectVariant(e, t) }, Shopify.OptionSelectors.prototype.selectVariant = function (t, e) { var o = this.product.getVariantById(t); if (null == o) return !1; for (var i = 0; i < this.selectors.length; i++) { var r = this.selectors[i].element, n = r.getAttribute("data-option"), a = o[n]; null != a && this.optionExistInSelect(r, a) && (r.value = a) } return "undefined" != typeof jQuery ? jQuery(this.selectors[0].element).trigger("change", e) : this.selectors[0].element.onchange(e), !0 }, Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) { for (var o = 0; o < t.options.length; o++)if (t.options[o].value == e) return !0 }, Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) { Shopify.isDefined(e) && this.setMessageElement(e), this.domIdPrefix = "product-" + this.product.id + "-variant-selector"; var o = document.getElementById(t); Shopify.each(this.buildSelectors(), function (t) { o.appendChild(t) }) }, Shopify.OptionSelectors.prototype.buildSelectors = function () { for (var t = 0; t < this.product.optionNames().length; t++) { var e = new Shopify.SingleOptionSelector(this, t, this.product.optionNames()[t], this.product.optionValues(t)); e.element.disabled = !1, this.selectors.push(e) } var o = this.selectorDivClass, i = this.product.optionNames(), r = Shopify.map(this.selectors, function (t) { var e = document.createElement("div"); if (e.setAttribute("class", o), i.length > 1) { var r = document.createElement("label"); r.htmlFor = t.element.id, r.innerHTML = t.name, e.appendChild(r) } return e.appendChild(t.element), e }); return r }, Shopify.OptionSelectors.prototype.selectedValues = function () { for (var t = [], e = 0; e < this.selectors.length; e++) { var o = this.selectors[e].element.value; t.push(o) } return t }, Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) { var o = this.selectedValues(), i = this.product.getVariant(o); i ? (this.variantIdField.disabled = !1, this.variantIdField.value = i.id) : this.variantIdField.disabled = !0, this.onVariantSelected(i, this, e), null != this.historyState && this.historyState.onVariantChange(i, this, e) }, Shopify.OptionSelectorsFromDOM = function (t, e) { var o = e.optionNames || [], i = e.priceFieldExists || !0, r = e.delimiter || "/", n = this.createProductFromSelector(t, o, i, r); e.product = n, Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e) }, Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors), Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (t, e, o, i) { if (!Shopify.isDefined(o)) var o = !0; if (!Shopify.isDefined(i)) var i = "/"; var r = document.getElementById(t), n = r.childNodes, a = (r.parentNode, e.length), s = []; Shopify.each(n, function (t, r) { if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) { var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*")); 0 == e.length && (a = n.length - (o ? 1 : 0)); var p = n.slice(0, a), l = o ? n[a] : "", c = (t.getAttribute("value"), { available: t.disabled ? !1 : !0, id: parseFloat(t.value), price: l, option1: p[0], option2: p[1], option3: p[2] }); s.push(c) } }); var p = { variants: s }; if (0 == e.length) { p.options = []; for (var l = 0; a > l; l++)p.options[l] = "option " + (l + 1) } else p.options = e; return p }, Shopify.SingleOptionSelector = function (t, e, o, i) { this.multiSelector = t, this.values = i, this.index = e, this.name = o, this.element = document.createElement("select"); for (var r = 0; r < i.length; r++) { var n = document.createElement("option"); n.value = i[r], n.innerHTML = i[r], this.element.appendChild(n) } return this.element.setAttribute("class", this.multiSelector.selectorClass), this.element.setAttribute("data-option", "option" + (e + 1)), this.element.id = t.domIdPrefix + "-option-" + e, this.element.onchange = function (o, i) { i = i || {}, t.updateSelectors(e, i) }, !0 }, Shopify.Image = { preload: function (t, e) { for (var o = 0; o < t.length; o++) { var i = t[o]; this.loadImage(this.getSizedImageUrl(i, e)) } }, loadImage: function (t) { (new Image).src = t }, switchImage: function (t, e, o) { if (t && e) { var i = this.imageSize(e.src), r = this.getSizedImageUrl(t.src, i); o ? o(r, t, e) : e.src = r } }, imageSize: function (t) { var e = t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./); return null != e ? e[1] : null }, getSizedImageUrl: function (t, e) { if (null == e) return t; if ("master" == e) return this.removeProtocol(t); var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i); if (null != o) { var i = t.split(o[0]), r = o[0]; return this.removeProtocol(i[0] + "_" + e + r) } return null }, removeProtocol: function (t) { return t.replace(/http(s)?:/, "") } }, Shopify.OptionSelectors.HistoryState = function (t) { this.browserSupports() && this.register(t) }, Shopify.OptionSelectors.HistoryState.prototype.register = function (t) { window.addEventListener("popstate", function (e) { t.selectVariantFromParamsOrDropdown({ popStateCall: !0 }) }) }, Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (t, e, o) { this.browserSupports() && (!t || o.initialLoad || o.popStateCall || Shopify.setParam("variant", t.id)) }, Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () { return window.history && window.history.replaceState };

var destroySlider = function (slider) {

  if (slider && slider.data('flexslider')) {
    var slider = slider.data('flexslider');
    var classNamespace = '.' + slider.vars.namespace; // Namespaced class selector
    if (slider.vars.controlNav) slider.controlNav.closest(classNamespace + 'control-nav').remove(); // Remove control elements if present
    if (slider.vars.directionNav) slider.directionNav.closest(classNamespace + 'direction-nav').remove(); // Remove direction-nav elements if present
    if (slider.vars.pausePlay) slider.pausePlay.closest(classNamespace + 'pauseplay').remove(); // Remove pauseplay elements if present
    slider.find('.clone').remove(); // Remove any flexslider clones
    slider.unbind(slider.vars.eventNamespace); // Remove events on slider
    if (slider.vars.animation != "fade") slider.container.unwrap(); // Remove the .flex-viewport div
    slider.container.removeAttr('style') // Remove generated CSS (could collide with 3rd parties)
    slider.container.unbind(slider.vars.eventNamespace); // Remove events on slider
    slider.slides.removeAttr('style'); // Remove generated CSS (could collide with 3rd parties)
    slider.slides.filter(classNamespace + 'active-slide').removeClass(slider.vars.namespace + 'active-slide'); // Remove slide active class
    slider.slides.unbind(slider.vars.eventNamespace); // Remove events on slides
    $(document).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from document for this instance only
    $(window).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from window for this instance only
    slider.stop(); // Stop the interval
    slider.removeData('flexslider'); // Remove data
  }
}

$(document)
  .on('shopify:block:select', function (e) {

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
      sliderBlock.select(blockId, $parentSection)
    }

  });

$(document)
  .on('shopify:block:deselect', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')) {
      sliderBlock.deselect($parentSection)
    }

  });

$(document)
  .on('shopify:section:load', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    header.init();

    if ($parentSection.hasClass('twitter-feed-section')) {
      $('.twitter-feed-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('cart-section')) {
      productFormListeners.init();
    }

    if ($parentSection.hasClass('faq-template-section')) {
      faqAccordion.init();
    }

    if ($parentSection.hasClass('slideshow-section')) {
      slideshow.init();
    }

    if ($parentSection.hasClass('map-section')) {
      map.init();
    }

    if ($parentSection.hasClass('page-details-section')) {
      map.init();
    }

    if ($parentSection.hasClass('contact-template-section')) {
      map.init();
    }

    if ($parentSection.hasClass('featured-product-section')) {
      product.init();
      utils.initializeTabs();
      utils.initializeAccordions();
    }

    if ($parentSection.hasClass('featured-collection-section')) {
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('video-section')) {
      video.init();
    }

    if ($parentSection.hasClass('page-details-section')) {
      video.init();
    }

    if ($parentSection.hasClass('product-template-section')) {
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('collection-template-section')) {
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('banner-template-section')) {
      $('.banner-flexslider').flexslider({ touch: false, controlNav: false, directionNav: false, animation: "fade" });
    }

    if ($parentSection.hasClass('search-template-section')) {
      collection.init();
    }

    if ($parentSection.hasClass('testimonial-section')) {
      testimonials.init();
    }
  });

$(document)
  .on('shopify:section:unload', function (e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);

    if ($parentSection.hasClass('social-feeds-section')) {
      $('.social-feeds-wrap').each(function (index, value) {
        social.unload($target);
      });
    }

    if ($parentSection.hasClass('slideshow-section')) {
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('featured-product-section')) {
      product.unload($target);
      utils.unload($target);
    }

    if ($parentSection.hasClass('featured-collection-section')) {
      collection.unload($target);
    }

    if ($parentSection.hasClass('product-template-section')) {
      product.unload($target);
    }

    if ($parentSection.hasClass('collection-template-section')) {
      collection.unload($target);
    }

  });

$(document)
  .on('shopify:section:select', function (e) {

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('twitter-feed-section')) {
      $('.twitter-feed-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('featured-collection-section')) {
      collection.init();
      product.init();
    }

  });

$(document)
  .on('shopify:section:deselect', function (e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);


    if ($parentSection.hasClass('social-feeds-section')) {
      $('.social-feeds-wrap').each(function (index, value) {
        social.unload();
      });
    }

  });

$(document)
  .on('shopify:section:reorder', function (e) {

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);
    banner.init();

  });

/*
 * Custom code
 */

// Gold sheet calculator
$(function () {

  $('[data-gold-sheet-calculator]').each(function () {
    var $calculator = $(this);

    var sheetWidth = 3.15;
    var sheetHeight = 3.15;

    if (typeof $calculator.attr('sheet-width') !== 'undefined') {
      sheetWidth = parseFloat($calculator.attr('sheet-width'));
    }

    if (typeof $calculator.attr('sheet-height') !== 'undefined') {
      sheetHeight = parseFloat($calculator.attr('sheet-height'));
    }

    var $selectors = $calculator.find('[data-select-mode]');
    var $modes = $calculator.find('[data-mode]');

    var $fields = $calculator.find('input');
    var $result = $calculator.find('[data-result]');
    var $resultUnit = $calculator.find('[data-result-unit]');

    var state = {
      mode: null,
      $mode: null
    };


    var calculators;


    function setMode(mode) {
      var $selector = $selectors.filter('[data-select-mode="' + mode + '"]');
      var $mode = $modes.filter('[data-mode="' + mode + '"]');

      $modes.not($mode).hide();
      $selectors.removeClass('active');
      $mode.show();
      $selector.addClass('active');

      state.mode = mode;
      state.$mode = $mode;

      calculateSheets();
    };

    function calculateRectangularSurface() {
      var $mode = state.$mode;

      var margin = 1 + parseFloat($mode.find('[data-extra-margin]').val()) / 100;

      var length = parseFloat($mode.find('[data-length]').val()) * margin;
      var width = parseFloat($mode.find('[data-width]').val()) * margin;

      return (length * width) / (sheetWidth * sheetHeight);
    };


    function calculateCircularSurface() {
      var $mode = state.$mode;

      var margin = 1 + parseFloat($mode.find('[data-extra-margin]').val()) / 100;

      var diameter = parseFloat($mode.find('[data-diameter]').val()) * margin;

      return (diameter * diameter) / (sheetWidth * sheetHeight);
    };


    calculators = {
      rectangular: calculateRectangularSurface,
      circular: calculateCircularSurface
    };


    function calculateSheets() {
      var calculator = calculators[state.mode];

      if (calculator) {
        setResult(calculator());
      } else {
        setResult(null);
      }
    };


    function setResult(result) {
      if (result) {
        var count = parseInt(Math.ceil(result));
        $result.text(count);
        $resultUnit.text(count == 1 ? 'sheet' : 'sheets');
      } else {
        $result.text('?');
        $resultUnit.text('sheets');
      }

    }


    function init() {
      $fields.change(calculateSheets);

      $selectors.click(function () {
        var $selector = $(this);
        setMode($selector.data('select-mode'));
      });

      setMode('rectangular');
    };


    init();

  });

});

document.addEventListener("readystatechange", (e) => {
  if(document.readyState === "complete") {
    markSubmenuOpenersHidden();

    window.addEventListener("resize", function() {
      markSubmenuOpenersHidden();
    });
  }

  // Keep submenu opener buttons available to keyboard and screen reader users.
  function markSubmenuOpenersHidden() {

    const subMenuOpeners = document.querySelectorAll(".menu .toggle-button.sub-menu-opener");

    if(subMenuOpeners && subMenuOpeners.length > 0) {
      subMenuOpeners.forEach((submenu) => {
        submenu.removeAttribute("inert");

        if(!submenu.hasAttribute("aria-expanded")) {
          submenu.setAttribute("aria-expanded", "false");
        }
      });
    }
  }
});
